/**
 * Create and store a new visitor session in local storage.
 * Session includes a unique ID and expiration time.
 * 
 * @function
 * @name setUniversalIdVisitSession
 * @returns {void}
 */
export const setUniversalIdVisitSession = (): void => {
    const expirationTime = Date.now() + 4 * 60 * 60 * 1000;  // Session expires every 4 hours
    // const expirationTime = Date.now() + 15 * 60 * 1000;  //  Shorter visitor session (15 minutes) - for testing purposes only
    const visitorSession = {
        sessionId: `visitor_${Math.random().toString(36).substring(2, 9)}`,
        expirationTime: expirationTime
    };
    localStorage.setItem('universalIdVisitSession', JSON.stringify(visitorSession));
};